<template>
	<div class="blog">
		<div class="col-main">
			<fluke-card>
				<header>
					<div class="title">
						Posts
					</div>
					<div class="description">
						Lista de todos os posts
					</div>
				</header>
				<main>

					<v-data-table
						:headers="headers"
						:items="posts"
						:rows-per-page-items="[15,30,60]"
						rows-per-page-text="Linhas pos página"
						class="inner-tables">

						<template v-slot:items="props">
							<td v-on:click="edit(props.item.id)">{{ props.item.title }}</td>
							<td v-on:click="edit(props.item.id)">{{ props.item.resume }}</td>
						</template>
					</v-data-table>

				</main>
				<footer v-if="permission.write">
					<fluke-button v-on:click.native="add">Adicionar Novo Post</fluke-button>
				</footer>
			</fluke-card>
		</div><!-- .col-main -->

		<div class="col-side">
			<fluke-side-card>
				<main>
					<fluke-button v-on:click.native="categories">Categorias</fluke-button><br/>
					<br v-if="permission.write"/>
					<fluke-button
						v-on:click.native="comments"
						v-if="permission.write">

						Comentários ({{peding_count}})
					</fluke-button>
				</main>
			</fluke-side-card>

			<fluke-side-card>
				<header>
					<div class="title">
						Palavras-Chave
					</div>
					<div class="description">
						Palavras-chave mais usadas
					</div>
				</header>
				<main>
					<table>
						<tbody>
							<tr
								v-for="(item,index) in most_used_tags"
								:key="'m_' + index">
								<td>{{item.tag}} ({{item.counter}})</td>
							</tr>
						</tbody>
					</table>
				</main>

			</fluke-side-card>

		</div><!-- .col-side -->
	</div>
</template>

<script>
import axios from 'axios'
import Card from '../../components/Main/Content/Card/Card.vue';
import SideCard from '../../components/Main/Content/SideCard/SideCard.vue';
import Button from '../../components/Main/Content/Button/Button.vue';

import permission from '../../mixins/permissions';

export default {
	mixins: [ permission ],
	data () {
		return {
			posts: [],
			headers: [
				{
					text: "Título",
					align: 'left',
					value: 'title'
				},
				{
					text: "Descrição",
					align: 'left',
					value: 'post'
				},
			],
			peding_count: 0,
			most_used_tags: [],
			permission: {
				read: false,
				write: false
			}
		}
	},
	components: {
		'fluke-card': Card,
		'fluke-side-card': SideCard,
		'fluke-button': Button
	},
	created () {
		this.getPosts();
		this.tags();
		this.permission = this.getUserPagePermission('blog');
		if( this.permission.read == false ) {
			this.$router.push('/');
		}
	},
	methods: {
		async getPosts () {
			const result = await axios.get( this.$myServerAddresses.blog + 'posts', {
                headers: {
                    'X-Fluke': this.$cookies.get('token')
                }
            });
			this.posts = result.data;

			axios
				.get( this.$myServerAddresses.blog + 'comments/peding', {
                    headers: {
                        'X-Fluke': this.$cookies.get('token'),
                    }
                })
				.then( result => {
					this.peding_count = result.data.length;
				});
		},
		add: function() {
			this.$router.push({ name: 'blog-add' });
		},
		edit: function( index ) {
			this.$router.push({ name: 'blog-edit', params: { id: index } });
		},
		categories: function() {
			this.$router.push({ name: 'blog-categories' });
		},
		comments: function() {
			this.$router.push({ name: 'blog-comments' });
		},
		tags: function() {
			axios
				.get( this.$myServerAddresses.blog + 'posts/tags', {
                    headers: {
                        'X-Fluke': this.$cookies.get('token'),
                    }
                })
				.then( result => {
					this.most_used_tags = result.data;
				});
		}
	}
}
</script>
